import $ from 'jquery';
import { hideButtonLoader, showButtonLoader } from '../../../../../../themes/Iqos3/assets/js/utils/button-loader';
export default class ConfirmModal {
    $modalButton;
    modalCallConditionFn;
    $modalElement;
    $modalForm;
    submitOtherwise;
    constructor($modalButton, modalCallConditionFn, $modalElement, $modalForm, submitOtherwise) {
        this.$modalButton = $modalButton;
        this.modalCallConditionFn = modalCallConditionFn;
        this.$modalElement = $modalElement;
        this.$modalForm = $modalForm;
        this.submitOtherwise = submitOtherwise;
    }
    init() {
        this.bindElements();
        this.initConfirmModalOnSpecificValue();
    }
    bindElements() {
        this.$modalButton.on('click', () => {
            if (!this.modalCallConditionFn()) {
                this.callConfirmModal(this.$modalElement, this.$modalForm, this.$modalButton);
            }
            else if (this.submitOtherwise) {
                this.$modalForm.trigger('submit').addClass('loading');
            }
        });
    }
    callConfirmModal($modal, $form, $button) {
        $modal
            .modal({
            autofocus: false,
            closable: false,
            onApprove: () => {
                if ($form.attr('action')) {
                    $form.trigger('submit').addClass('loading');
                }
                else {
                    $.ajax({
                        url: $form.data('url'),
                        method: $form.data('method'),
                        beforeSend: () => {
                            if ($button) {
                                showButtonLoader($button);
                            }
                        },
                    })
                        .done(() => {
                        if ($form.data('reload-on-success')) {
                            window.location.reload();
                        }
                    })
                        .always(() => {
                        if ($button) {
                            hideButtonLoader($button);
                        }
                    });
                }
            },
        })
            .modal('show');
    }
    initConfirmModalOnSpecificValue() {
        const $confirmModalValueInput = $('.js__confirm-modal-value-input');
        if ($confirmModalValueInput.length) {
            const $form = $confirmModalValueInput.closest('form');
            const $submitButton = $form.find('[type="submit"]');
            $submitButton.on('click', e => {
                e.preventDefault();
                let shouldShowModal = false;
                let $confirmModal;
                $confirmModalValueInput.each((index, input) => {
                    const $input = $(input);
                    const confirmModalValue = $input.data('confirm-modal-value');
                    const inputValue = $input.is(':checked');
                    if (confirmModalValue === inputValue) {
                        shouldShowModal = true;
                        $confirmModal = $($input.data('confirm-modal-selector'));
                    }
                });
                if (shouldShowModal && $confirmModal) {
                    $form.removeClass('loading');
                    this.callConfirmModal($confirmModal, $form);
                }
                else {
                    $form.submit();
                }
            });
        }
    }
}
